import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { InstructorFacade } from '../facades/instructor.facade';

export function instructorCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const instructorFacade = inject(InstructorFacade);
        instructorFacade.clear();

        return true;
    };
}
